import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ServiceActivityMonitorKey } from '../configs/services';
import { getServiceActivityMonitorData } from '../api/services';
import { ServiceActivityResponseDataType } from '../@types';

export const useGetServiceActivityMonitorData = (refreshEnabled: boolean): UseQueryResult<ServiceActivityResponseDataType[]> => {
  return useQuery({
    queryKey: [ServiceActivityMonitorKey],
    queryFn: () => getServiceActivityMonitorData(),
    refetchInterval: refreshEnabled ? 2 * 60 * 1000 : false
  });
};